import "./Campaigns.scss";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import axios from "../../api/axios";
import { AuthContext } from "../../contexts/AuthContext";

import { useNavigate, } from "react-router-dom";
import CampaignSummaryPanel from "../../components/Campaigns/CampaignSummaryPanel";
import DropDownList from "../../components/forms/DropDownList/DropDownList";
import AdvancedDropDownList from "../../components/forms/DropDownList/AdvancedDropDownList";
import DateRangeSelect, { formatDateRangeForDropdown } from "../../components/forms/DateRangeSelect/DateRangeSelect";
import UserLevelRestrict from "../../components/UserLevelRestrict/UserLevelRestrict";
import { TOP_LEVEL_NAV_ROUTES } from "../../config/NavRoutes";
import { getAllCampaignsRoute, getAllCampaignsV2Route, getUserCampaigns, appAccessTokenRoute, userListAllUsersRoute, getAllClientsRoute, toggleStarredCampaignRoute, duplicateCampaignRoute, setCampaignArchivedRoute } from "../../api/routes";
import { getRegionsDropDownListData } from "../../helpers/Regions";
import { alphaTypePrimer, filterList, searchList, toStringPrimer } from "../../helpers/ListFunctions";
import { orderCampaignsAccordingtoStatus } from "../../helpers/CampaignsHelper";
import { ACCOUNT_TYPES } from "../../helpers/AccountTypes";
// import setComponentSearchTerm from "../../components/forms/SearchBox/SearchBox";
import LeftColorBlockBox from "../../components/LeftColorBlockBox/LeftColorBlockBox";
import { updateComponentSearchTerm } from "../../components/forms/SearchBox/SearchBox";
import { debounce } from "lodash";
import { IconJsxer } from "../../helpers/IconHelper";
import PageTopBanner from "../../components/PageTopBanner/PageTopBanner";


// Add sort and status options for dropdowns
const CAMPAIGN_SORT_OPTIONS = [
    // Removed: { label: "All", value: "", deselect: true },
    { label: "Last modified", value: "Last modified" },
    { label: "Last modified by me", value: "Last modified by me" },
    { label: "Last modified by others", value: "Last modified by others" },
    { label: "Starred", value: "Starred" },
    { label: "Upcoming streams", value: "Upcoming streams" },
    { label: "Live streams", value: "Live streams" },
    { label: "Campaign name A to Z", value: "Campaign name A to Z" },
    { label: "Owner A to Z", value: "Owner A to Z" },
    { label: "Client A to Z", value: "Client A to Z" },
];
const CAMPAIGN_STATUS_OPTIONS = [
    { label: "All", value: "", deselect: true },
    { label: "Active", value: "active" },
    { label: "Draft", value: "draft" },
];

// Modified filter options
const getModifiedOptions = (customRange) => {
    const customLabel = customRange && customRange.from && customRange.to
        ? formatDateRangeForDropdown(customRange.from, customRange.to)
        : "Custom date range";
    
    return [
        { label: "All", value: "", deselect: true },
        { label: "Today", value: "today" },
        { label: "Last week", value: "last_week" },
        { label: "Last month", value: "last_month" },
        { label: "This year", value: "this_year" },
        { label: "Last year", value: "last_year" },
        { label: customLabel, value: "custom" }
    ];
};

// Helper to get date range from option
const getDateRangeFromOption = (option) => {
    const now = new Date();
    let from = null, to = null;
    switch(option) {
        case "today":
            from = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
            // Set 'to' to end of today (23:59:59.999)
            to = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999).getTime();
            break;
        case "last_week":
            from = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7).getTime();
            to = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999).getTime();
            break;
        case "last_month":
            from = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate()).getTime();
            to = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999).getTime();
            break;
        case "this_year":
            from = new Date(now.getFullYear(), 0, 1).getTime();
            to = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999).getTime();
            break;
        case "last_year":
            from = new Date(now.getFullYear() - 1, 0, 1).getTime();
            to = new Date(now.getFullYear() - 1, 11, 31, 23, 59, 59, 999).getTime();
            break;
        default:
            break;
    }
    return { from, to };
};

// Helper to find the current index for a value in a DropDownList
const getIndexByValue = (items, value) => items.findIndex(item => item.value === value);

const TAB_MY = "my";
const TAB_STARRED = "starred";
const TAB_ARCHIVED = "archived";
const TAB_ALL = "all";

const Campaigns = () => {
    const navigate = useNavigate();

    // --- State ---
    const [modifiedOption, setModifiedOption] = useState(getModifiedOptions(null)[0].value);
    const [modifiedFilter, setModifiedFilter] = useState({from: null, to: null});
    const [showDateRangePicker, setShowDateRangePicker] = useState(false);
    const [modifiedFilterAnchor, setModifiedFilterAnchor] = useState(null);

    // --- People filter state ---
    const [peopleFilter, setPeopleFilter] = useState([]);
    const [pendingPerson, setPendingPerson] = useState(null);
    const [pendingPersonMenuOpen, setPendingPersonMenuOpen] = useState(false);
    const [pendingPersonMenuAnchor, setPendingPersonMenuAnchor] = useState(null);
    const [peopleDropdownOpen, setPeopleDropdownOpen] = useState(false);

    // --- Client filter state ---
    const [clientFilter, setClientFilter] = useState([]);
    const [pendingClient, setPendingClient] = useState(null);
    const [pendingClientRegionMenuOpen, setPendingClientRegionMenuOpen] = useState(false);
    const [pendingClientRegionMenuAnchor, setPendingClientRegionMenuAnchor] = useState(null);
    const [clientDropdownOpen, setClientDropdownOpen] = useState(false);

    // --- All users/clients state ---
    const [allUsers, setAllUsers] = useState([]);
    const [allClients, setAllClients] = useState([]);

    const [statusFilter, setStatusFilter] = useState("");
    const [sortOption, setSortOption] = useState("Last modified");
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [numberOfPages, setNumberOfPages] = useState(1);
    const [hasMoreCampaigns, setHasMoreCampaigns] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [campaignsData, setCampaignsData] = useState([]);
    const [displayCampaignsData, setDisplayCampaignsData] = useState([]);
    const [listView, setListView] = useState(true);
    const [selectedCampaignId, setSelectedCampaignId] = useState(null);

    // --- Tabs ---
    const [activeTab, setActiveTab] = useState(TAB_MY);

    // --- Display summary for dropdowns ---
    const owner = peopleFilter.find(p => p.type === "owner");
    const producerCount = peopleFilter.filter(p => p.type === "shared").length;
    const peopleSummary = [
        owner ? `Owner: ${owner.name}` : null,
        producerCount > 0 ? `Producers: ${producerCount}` : null
    ].filter(Boolean).join(", ") || "Add People";

    const clientSummary = clientFilter.length > 0
        ? clientFilter.map(c => `${c.clientName} (${c.region})`).join(", ")
        : "Add Client";

    // --- Fetch all users/clients on mount ---
    useEffect(() => {
        axios.get(userListAllUsersRoute, { withCredentials: true })
            .then(res => {
                const users = Array.isArray(res.data.users)
                    ? res.data.users
                    : Array.isArray(res.data.allusers)
                        ? res.data.allusers
                        : [];
                setAllUsers(users.map(u => ({
                    _id: u._id,
                    name: (u.name !== "TWITCH_LOCAL" && u.name) ? u.name : (u.firstName ? `${u.firstName} ${u.lastName}` : "Unknown")
                })));
            })
            .catch(() => setAllUsers([]));
        axios.get(getAllClientsRoute, { withCredentials: true })
            .then(res => {
                setAllClients(res.data.clients || []);
            })
            .catch(() => setAllClients([]));
    }, []);

    // --- Handlers ---
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    const handleStatusChange = (e, id, item) => setStatusFilter(item.value);
    const handleSortChange = (e, id, item) => setSortOption(item.value);

    // --- Click outside logic for dropdowns and submenus ---
    React.useEffect(() => {
        function handleClickOutside(e) {
            let closed = false;
            // Close people dropdown/submenu if open and click is outside both
            if (peopleDropdownOpen || pendingPersonMenuOpen) {
                const peopleDropdown = document.querySelector('.people-dropdown-list');
                const peopleMenu = document.querySelector('.people-type-menu');
                if (
                    peopleDropdown &&
                    !peopleDropdown.contains(e.target) &&
                    (!peopleMenu || !peopleMenu.contains(e.target))
                ) {
                    setPeopleDropdownOpen(false);
                    setPendingPerson(null);
                    setPendingPersonMenuOpen(false);
                    setPendingPersonMenuAnchor(null);
                    closed = true;
                }
            }
            // Close client dropdown/submenu if open and click is outside both
            if (clientDropdownOpen || pendingClientRegionMenuOpen) {
                const clientDropdown = document.querySelector('.client-dropdown-list');
                const clientMenu = document.querySelector('.client-region-menu');
                if (
                    clientDropdown &&
                    !clientDropdown.contains(e.target) &&
                    (!clientMenu || !clientMenu.contains(e.target))
                ) {
                    setClientDropdownOpen(false);
                    setPendingClient(null);
                    setPendingClientRegionMenuOpen(false);
                    setPendingClientRegionMenuAnchor(null);
                    closed = true;
                }
            }
            // Do NOT call e.preventDefault() or e.stopPropagation() here, so the click will propagate and open the next dropdown if needed
        }
        document.addEventListener('mousedown', handleClickOutside, true); // use capture phase
        return () => document.removeEventListener('mousedown', handleClickOutside, true);
    }, [peopleDropdownOpen, pendingPersonMenuOpen, clientDropdownOpen, pendingClientRegionMenuOpen]);

    // --- Modified filter ---
    const handleModifiedOption = (e, id, item) => {
        const newValue = item.value;
        setModifiedOption(newValue);
        
        if (newValue === "") {
            // Clear all filters
            setModifiedFilter({from: null, to: null});
            setShowDateRangePicker(false);
        } else if (newValue === "custom") {
            // Store the anchor element and open calendar picker
            const anchorEl = document.getElementById('modifiedFilter');
            setModifiedFilterAnchor(anchorEl);
            setShowDateRangePicker(true);
        } else {
            // Use predefined date range
            setModifiedFilter(getDateRangeFromOption(newValue));
            setShowDateRangePicker(false);
        }
    };
    
    const handleCustomDateRangeConfirm = (id, range) => {
        setModifiedFilter(range);
        setShowDateRangePicker(false);
    };
    
    const handleCustomDateRangeCancel = () => {
        // If no date range was selected, reset to 'All'
        if (!modifiedFilter.from || !modifiedFilter.to) {
            setModifiedOption("");
            setModifiedFilter({from: null, to: null});
        }
        setShowDateRangePicker(false);
    };

    // --- Fetch Campaign List using V2 API ---
    const [authContext, setAuthContext] = useContext(AuthContext);

    const fetchCampaignListV2 = React.useCallback(debounce(() => {
        // Prepare people array for API: [{userId, type}]
        let peopleArr = [];
        let status = statusFilter;
        let filters = {
            people: [],
            status: "",
            client: clientFilter,
            modified: modifiedFilter,
            starredCampaigns: null,
            archived: null,
            //sort: sortOption,
            searchTerm: searchTerm || "",
            page: currentPage,
            pageSize: 15
        };

        if (activeTab === TAB_MY) {
            // Only show campaigns where user is owner or producer
            if (authContext && authContext.userData) {
                peopleArr = {
                    "filter1": [
                        { userId: authContext.userData._id, type: "owner" },
                        { userId: authContext.userData._id, type: "shared" },
                    ],
                    "filter2": [
                        ...peopleFilter.filter((val) => val.type !== "owner").map(p => ({
                            userId: p._id,
                            type: "shared"
                        }))
                    ]
                };
            }
            filters.archived = false;
            filters.people = peopleArr;
            filters.status = status; // allow status filter (no archived)
        } else if (activeTab === TAB_STARRED) {
            // Only show campaigns starred by the user
            if (authContext && authContext.userData) {
                peopleArr = {
                    "filter1": [
                        { userId: authContext.userData._id, type: "owner" },
                        { userId: authContext.userData._id, type: "shared" },
                    ],
                    "filter2": [
                        ...peopleFilter.filter((val) => val.type !== "owner").map(p => ({
                            userId: p._id,
                            type: "shared"
                        }))
                    ]
                };
            }
            filters.archived = false;
            filters.people = peopleArr;
            filters.starredCampaigns = authContext?.userData?.starredCampaigns || [];
        } else if (activeTab === TAB_ARCHIVED) {
            // Only show the user's archived campaigns
            if (authContext && authContext.userData) {
                peopleArr = {
                    "filter1": [
                        { userId: authContext.userData._id, type: "owner" },
                        { userId: authContext.userData._id, type: "shared" },
                    ],
                    "filter2": [
                        ...peopleFilter.filter((val) => val.type !== "owner").map(p => ({
                            userId: p._id,
                            type: "shared"
                        }))
                    ]
                };
            }
            filters.archived = true;
            filters.people = peopleArr;
            filters.status = "archived";
        } else if (activeTab === TAB_ALL) {
            // All campaigns, allow status filter (no archived in dropdown)
            filters.people = {
                "filter2": peopleFilter.map(p => ({
                    userId: p._id,
                    type: p.type
                }))
            };
            filters.status = status;
        }

        console.log("filters.people = ", filters.people);

        setIsLoading(true);
        axios.post(getAllCampaignsV2Route, filters, { withCredentials: true })
        .then(res => {
            const newCampaigns = res.data.campaigns || [];
            if (currentPage === 1) {
                setCampaignsData(newCampaigns);
                setDisplayCampaignsData(newCampaigns);
            } else {
                // Append to existing data for load more
                setCampaignsData(prev => [...prev, ...newCampaigns]);
                setDisplayCampaignsData(prev => [...prev, ...newCampaigns]);
            }
            setNumberOfPages(res.data.numberOfPages || 1);
            setHasMoreCampaigns(currentPage < (res.data.numberOfPages || 1));
            setIsLoading(false);
        })
        .catch(() => {
            if (currentPage === 1) {
                setCampaignsData([]);
                setDisplayCampaignsData([]);
            }
            setNumberOfPages(1);
            setHasMoreCampaigns(false);
            setIsLoading(false);
        });
    }, 300), [
        peopleFilter, statusFilter, clientFilter, modifiedFilter, /*sortOption,*/ searchTerm, currentPage, activeTab, authContext
    ]);

    const toggleCampaignAsStarred = (campaignID) => {
         axios
            .post(toggleStarredCampaignRoute, {
                campaignID: campaignID
            })
            .then((response) => {
                // console.log('Starred campaign response: ', response);
                console.log("response.data = ", response.data);
                if (response.data.success) {
                    console.log("Starred campaign successfully updated");
                    console.log("response.data = ", response.data);
                    // Update the auth context with the new user data
                    setAuthContext({
                        ...authContext,
                        userData: {
                            ...authContext.userData,
                            starredCampaigns: response.data.user.starredCampaigns
                        }
                    });
                
                    // Refresh the campaign list to update the starred status
                    fetchCampaignListV2();
                }
            });
    }

    const archiveCampaign = (campaignID) => {
            axios.post(setCampaignArchivedRoute, {
                campaignID: campaignID,
                setArchived: true
            })
            .then((response) => {
                if (response.data.success) {
                    console.log("Campaign archived successfully");
                    fetchCampaignListV2();
                }
            });
    }

    useEffect(() => {
        fetchCampaignListV2();
        // eslint-disable-next-line
    }, [peopleFilter, statusFilter, clientFilter, modifiedFilter, /*sortOption,*/ searchTerm, currentPage, activeTab, authContext]);

    // Load more for V2
    const handleLoadMore = () => {
        if (!isLoading && hasMoreCampaigns) {
            setCurrentPage(prevPage => prevPage + 1);
        }
    };

    const createCampaign = () => {
        navigate(TOP_LEVEL_NAV_ROUTES.CAMPAIGN_SETUP);
    };

    console.log("starredCampaigns = ", authContext?.userData?.starredCampaigns);
    // --- Render ---
    // Duplicate campaign handler
    const handleDuplicateCampaign = (campaignId) => {
        if (!window.confirm("Are you sure you want to duplicate this campaign?")) return;
        axios.post(duplicateCampaignRoute, { campaignID: campaignId }, { withCredentials: true })
            .then((response) => {
                if (response.data.success) {
                    toast.success(`Created copy of '${response.data.originalCampaign.campaignName}'`);
                    fetchCampaignListV2();
                } else {
                    toast.error("Failed to duplicate campaign.");
                }
            })
            .catch((err) => {
                toast.error("Error duplicating campaign.");
            });
    };

    // Campaign selection handler
    const handleSelectCampaign = (campaignId) => {
        setSelectedCampaignId(selectedCampaignId === campaignId ? null : campaignId);
    };

    // Handler to deselect when clicking outside campaign rows
    const handleContainerClick = (e) => {
        // Only deselect if clicking directly on the container, not on child elements
        if (e.target === e.currentTarget) {
            setSelectedCampaignId(null);
        }
    };

    return (
        <div className="content-page-container">
            <PageTopBanner />
            
            <div className="content-page-top">
                <div className="fl-column grow">
                {/* Title and search row */}
                <div className="content-top-row">
                    {/* <ContentTopProfile showSearchBox={false} /> */}
                    <div className="fl-row-slim">
                        <h4 className='page-title'>Campaigns</h4>
                        <div className='heading-button-container'>
                            <UserLevelRestrict accountType={ACCOUNT_TYPES.producer} element={
                                    <div className={`standard-button heading-slim-button button-active`} onClick={createCampaign}>
                                        <div className="fl-row">
                                            { IconJsxer.GetIcon(IconJsxer.ICONS.plus, IconJsxer.ICON_STYLES.roundPanelButtonSmall) }
                                            <div>Create{!listView && <br />} Campaign</div>
                                        </div>
                                    </div>
                                }
                            />
                        </div>
                    </div>
                    <div  className="spacing-line"></div>
                    <input
                        type="text"
                        placeholder="Search by campaign, client, or collaborator names"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="campaigns-search-input"
                    />
                </div>
                {/* Tabs */}
                <div className="campaign-tabs" style={{ display: "flex", marginBottom: 16 }}>
                    <div
                        className={`campaign-tab${activeTab === TAB_MY ? " active" : ""}`}
                        onClick={() => { setActiveTab(TAB_MY); setCurrentPage(1); }}
                    >
                        My Campaigns
                    </div>
                    <div
                        className={`campaign-tab${activeTab === TAB_STARRED ? " active" : ""}`}
                        onClick={() => { setActiveTab(TAB_STARRED); setCurrentPage(1); }}
                    >
                        Starred
                    </div>
                    <div
                        className={`campaign-tab${activeTab === TAB_ARCHIVED ? " active" : ""}`}
                        onClick={() => { setActiveTab(TAB_ARCHIVED); setCurrentPage(1); }}
                    >
                        Archived
                    </div>
                    <UserLevelRestrict accountType={ACCOUNT_TYPES.twitchSuperUser} element={
                        <div
                            className={`campaign-tab${activeTab === TAB_ALL ? " active" : ""}`}
                            onClick={() => { setActiveTab(TAB_ALL); setCurrentPage(1); }}
                        >
                            All Campaigns
                        </div>
                    }/>
                </div>
                <div className="filters-container form-holder" style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", flex: 1 }}>
                        {/* Show people filter on All tabs */}
                        
                        <AdvancedDropDownList
                            id="peopleFilter"
                            items={allUsers}
                            selectedItems={peopleFilter}
                            onSelect={user => {
                                // Toggle user selection
                                if (peopleFilter.some(p => p._id === user._id)) {
                                    setPeopleFilter(peopleFilter.filter(p => p._id !== user._id));
                                } else {
                                    setPeopleFilter([...peopleFilter, { _id: user._id, name: user.name, type: null }]);
                                }
                            }}
                            summary={peopleSummary}
                            icon={null}
                            placeholder="Add People"
                            submenuOptionsFunc={user => ["owner", "shared", "either"]}
                            onSubmenuSelect={(user, type) => {
                                // Assign type to user
                                if (peopleFilter.some(p => p._id === user._id && p.type === type)) {
                                    setPeopleFilter(peopleFilter.filter(p => !(p._id === user._id && p.type === type)));
                                } else if (type === "owner") {
                                    setPeopleFilter([
                                        ...peopleFilter.filter(p => p.type !== "owner"),
                                        { _id: user._id, name: user.name, type }
                                    ]);
                                } else {
                                    setPeopleFilter([...peopleFilter, { _id: user._id, name: user.name, type }]);
                                }
                            }}
                            getSelectedSubmenu={user => peopleFilter.filter(p => p._id === user._id).map(p => p.type).filter(Boolean)}
                            enabled={true}
                            className="filter"
                        />
                        
                         {/* Only show status filter on My Campaigns, Starred Campaigns and All Campaigns tabs */}
                        {(activeTab === TAB_MY || activeTab === TAB_ALL || activeTab === TAB_STARRED) && (
                            <DropDownList
                                id="statusFilter"
                                selectFunc={handleStatusChange}
                                currentIndex={getIndexByValue(CAMPAIGN_STATUS_OPTIONS, statusFilter)}
                                deselectedLabel="Status"
                                icon={null}
                                items={CAMPAIGN_STATUS_OPTIONS.map((opt, idx) => ({
                                    id: opt.value,
                                    label: opt.label,
                                    index: idx,
                                    value: opt.value,
                                    deselect: opt.deselect
                                }))}
                                className="filter"
                                deselectedClass=""
                                selectedClass="default-selected"
                                listClass="default-selected"
                                showErrors={false}
                                enabled={true}
                                error=""
                            />
                        )}
                        {/* Client filter always shown */}
                        <AdvancedDropDownList
                            id="clientFilter"
                            items={allClients}
                            selectedItems={clientFilter}
                            onSelect={client => {
                                // Toggle client selection
                                if (clientFilter.some(c => c.clientName === client.clientName)) {
                                    setClientFilter(clientFilter.filter(c => c.clientName !== client.clientName));
                                } else {
                                    setClientFilter([...clientFilter, { clientName: client.clientName, region: null }]);
                                }
                            }}
                            summary={clientSummary}
                            //icon="briefcase"
                            icon={null}
                            placeholder="Add Client"
                            submenuOptionsFunc={client => client.regions || []}
                            onSubmenuSelect={(client, region) => {
                                if (clientFilter.some(c => c.clientName === client.clientName && c.region === region)) {
                                    setClientFilter(clientFilter.filter(c => !(c.clientName === client.clientName && c.region === region)));
                                } else {
                                    setClientFilter([...clientFilter, { clientName: client.clientName, region }]);
                                }
                            }}
                            getSelectedSubmenu={client => clientFilter.filter(c => c.clientName === client.clientName).map(c => c.region).filter(Boolean)}
                            enabled={true}
                            className="filter"
                        />
                        {/* Modified filter always shown */}
                        <DropDownList
                            id="modifiedFilter"
                            selectFunc={handleModifiedOption}
                            currentIndex={getIndexByValue(getModifiedOptions(modifiedFilter), modifiedOption)}
                            deselectedLabel="Modified"
                            //icon="calendar"
                            icon={null}
                            items={getModifiedOptions(modifiedFilter).map((opt, idx) => ({
                                id: opt.value,
                                label: opt.label,
                                index: idx,
                                value: opt.value,
                                deselect: opt.deselect
                            }))}
                            className="filter"
                            deselectedClass=""
                            selectedClass="default-selected"
                            listClass="default-selected"
                            showErrors={false}
                            enabled={true}
                            error=""
                        />
                    </div>
                    {/* Sort dropdown all the way to the right */}
                    {/*<div style={{ marginLeft: "auto" }}>
                        <DropDownList
                            id="sortOption"
                            selectFunc={handleSortChange}
                            currentIndex={getIndexByValue(CAMPAIGN_SORT_OPTIONS, sortOption)}
                            deselectedLabel="Sort"
                            icon="priority"
                            items={CAMPAIGN_SORT_OPTIONS.map((opt, idx) => ({
                                id: opt.value,
                                label: opt.label,
                                index: idx,
                                value: opt.value,
                                deselect: opt.deselect
                            }))}
                            className="filter"
                            deselectedClass=""
                            selectedClass="default-selected"
                            listClass="default-selected"
                            showErrors={false}
                            enabled={true}
                            error=""
                            style={{ minWidth: 140 }}
                        />
                    </div>*/}
                </div>
                </div>
            </div>
            <div className={`content-page-content-container`}>
                <div className="content-page-main-content campaign-main-content">
                    <div className="campaigns-panel">
                        <div className={`campaigns-container${listView ? ' compact' : ''}`}>
                            {/* {listView &&
                                <UserLevelRestrict accountType={ACCOUNT_TYPES.producer} element={
                                        <div className={`create-campaign-button button-active${listView ? ' wide-btn' : ''}`} onClick={createCampaign}>
                                            <div className={listView ? 'fl-row' : ''}>
                                                <i className="fa fa-plus" aria-hidden="true"></i>
                                                <h3>Create{!listView && <br />} Campaign</h3>
                                            </div>
                                        </div>
                                    }
                                />
                            } */}
                            {listView &&
                                <div className="horizontal-scroll-container">
                                    <div className="clist-headings-container grow">
                                        <div className='fl-row list-view-content'>
                                            <div className='fl-row list-view-data-block fixed-icon'>
                                            </div>    
                                            <div className='fl-row list-view-data-block wide'>
                                                Campaign Title
                                            </div>
                                            <div className='fl-row list-view-data-block wide'>
                                                Owner
                                            </div>
                                            <div className='fl-row list-view-data-block wide'>
                                                Status
                                            </div>
                                            <div className='fl-row list-view-data-block wide'>
                                                Client
                                            </div>
                                            <div className='fl-row list-view-data-block narrow'>
                                                Last Modified
                                            </div>
                                            <div className="fl-row list-view-data-block actions"></div>
                                        </div>
                                    </div>
                                    <div 
                                        className="scroll-container-vertical-only"
                                        onClick={handleContainerClick}
                                    >
                                        {!isLoading && displayCampaignsData.length === 0 ? (
                                            <div className="empty-campaigns-state">
                                                <div className="empty-campaigns-image">
                                                    <img src={'/assets/icons/No_Campaigns.svg'} alt="No Campaigns" />
                                                </div>
                                                <h3 className="empty-campaigns-title">No Campaigns</h3>
                                                <p className="empty-campaigns-description">
                                                    Click 'Create Campaign' button or ask to be added to an existing campaign. 
                                                    Campaigns you own and those shared with you will be listed here.
                                                </p>
                                            </div>
                                        ) : (
                                            displayCampaignsData.map((val, i) => {
                                                return (<CampaignSummaryPanel 
                                                    campaign={val} 
                                                    key={val._id}  
                                                    isStarred={(authContext?.userData?.starredCampaigns?.map(id => id) || []).indexOf(val._id) !== -1} 
                                                    toggleCampaignAsStarred={toggleCampaignAsStarred} 
                                                    archiveCampaign={archiveCampaign}
                                                    listView={listView} 
                                                    //searchFunc={searchClientList} 
                                                    onDuplicate={handleDuplicateCampaign}
                                                    isSelected={selectedCampaignId === val._id}
                                                    onSelect={handleSelectCampaign}
                                                />);
                                            })
                                        )}
                                    </div>
                                </div>
                            }
                            {!listView &&
                                <div 
                                    className={`scroll-container ${listView ? 'scroll-list' : 'scroll-panels'}`}
                                    onClick={handleContainerClick}
                                >
                                    {!isLoading && displayCampaignsData.length === 0 ? (
                                        <div className="empty-campaigns-state">
                                            <div className="empty-campaigns-image">
                                                {/* Image placeholder */}
                                            </div>
                                            <h3 className="empty-campaigns-title">No Campaigns</h3>
                                            <p className="empty-campaigns-description">
                                                Click 'Create Campaign' button or ask to be added to an existing campaign. 
                                                Campaigns you own and those shared with you will be listed here.
                                            </p>
                                        </div>
                                    ) : (
                                        displayCampaignsData.map((val, i) => {
                                            return (<CampaignSummaryPanel 
                                                campaign={val} 
                                                key={val._id}  
                                                isStarred={(authContext?.userData?.starredCampaigns?.map(id => id) || []).indexOf(val._id) !== -1} 
                                                toggleCampaignAsStarred={toggleCampaignAsStarred} 
                                                archiveCampaign={archiveCampaign}
                                                listView={listView} 
                                                //searchFunc={searchClientList} 
                                                onDuplicate={handleDuplicateCampaign}
                                                isSelected={selectedCampaignId === val._id}
                                                onSelect={handleSelectCampaign}
                                            />);
                                        })
                                    )}
                                </div>
                            }
                        </div>
                        {hasMoreCampaigns && (
                            <div className="load-more-container">
                                <button 
                                    className={`load-more-button ${isLoading ? 'loading' : ''}`}
                                    onClick={handleLoadMore}
                                    disabled={isLoading}
                                >
                                    {isLoading ? 'Loading...' : 'Load more'}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            
            {/* Date Range Picker Popup */}
            <DateRangeSelect
                id="customDateRange"
                onRangeConfirm={handleCustomDateRangeConfirm}
                onCancel={handleCustomDateRangeCancel}
                initialRange={modifiedFilter}
                allowPast={true}
                isOpen={showDateRangePicker}
                anchorElement={modifiedFilterAnchor}
            />
        </div>
    );
}

export default Campaigns;